import React, { Component } from 'react'
import PropTypes from 'prop-types'
import TeamForm from './TeamForm.jsx'
//import _ from 'lodash'

class AddTeamComponent extends Component{
  componentDidMount() {
    this.props.fetchData()
  }

  render() {
    if (this.props.team.title) {
      const team = this.props.team
      return <div><TeamForm team={team}></TeamForm></div>
    }
    return <div></div>
  }
}

AddTeamComponent.propTypes = {
  fetchData: PropTypes.func.isRequired,
  team: PropTypes.object.isRequired,
}

export default AddTeamComponent
